module.exports = __webpack_public_path__ + "img/play.3558b7a0.png";